import angular from 'angular'
import template from './template.html'

angular.module('nominas.fondoreserva')
  .component('nominasFondoreservaLauncher', {
    template: template,
  });



// WEBPACK FOOTER //
// ./src/nominas/fondoreserva/components/launcher/component.js